import { ContextConsumer } from '@lit/context';
import { localized, msg } from '@lit/localize';
import { t } from '../../../../services/runtime-i18n';
import { LitElement, TemplateResult, html, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { choose } from 'lit/directives/choose.js';
import urlJoin from 'url-join';
import { INSIGHTS_BASE_PATH } from '../../../../constants';
import { menuDataContext } from '../../../../context/menu-data';
import { DirtyFormController } from '../../../../controllers/dirty-form-controller';
import { flagContext } from '../../../../feature-flags';
import { INSIGHTS_SLUG } from '../../../../types';
import styles from '../menu.styles.scss';
export const REPORTING_INSIGHTS_MENU_TAG = 'platform-reporting-insights-menu' as const;

@customElement(REPORTING_INSIGHTS_MENU_TAG)
@localized()
export class ReportingInsightsMenu extends LitElement {
  static override styles = [styles];

  dirtyFormController = new DirtyFormController(this);
  _menuData = new ContextConsumer(this, { context: menuDataContext, subscribe: true });
  _flags = new ContextConsumer(this, { context: flagContext, subscribe: true });

  override render(): TemplateResult<1> | typeof nothing {
    const reportingMenuItem = this._menuData.value?.[INSIGHTS_SLUG]?.features
      ?.flatMap((f) => f.items)
      .find((i) => i.id === 'insights.menu.reporting');
    if (reportingMenuItem == undefined) {
      return nothing;
    }
    const reportingHref = reportingMenuItem.absolutePath
      ? urlJoin('/', reportingMenuItem.link)
      : urlJoin(INSIGHTS_BASE_PATH, reportingMenuItem.link);
    return html`<menu>
      <li>
        <a href=${reportingHref}> ${t(reportingMenuItem.id, reportingMenuItem.name)} </a>
      </li>
      ${choose(this._flags.value?.['unified-auditing'], [
        [
          true,
          () => html`
            <li>
              <a href=${urlJoin(INSIGHTS_BASE_PATH, 'reporting') + '?id=4609206e-c68d-4b93-867a-a4afb8f964bf'}
                >${msg('Unified Auditing')}</a
              >
            </li>
          `,
        ],
      ])}
    </menu>`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [REPORTING_INSIGHTS_MENU_TAG]: ReportingInsightsMenu;
  }
}
